import dayjs from "dayjs"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import LDSRipple from "src/components/common/LDS/LDSRipple/LDSRipple"
import notificationStore from "../notificationStore"
import NotificationTypes from "../Types/NotificationTypes"
import "./NotificationMenu.css"

interface State {
    notificationsState: any
}

class NotificationMenu extends Component<{}, State> {

    history: Array<number> = [-Infinity]

    state = {
        notificationsState: notificationStore.state
    }

    componentDidMount() {
        notificationStore.debounce({ target: { value: "" } })
    }

    showOrHideRowControls = (id: number, show: boolean, force?: boolean) => {
        this.killStragglers(id)
        if (notificationStore.state.rowMenuId < 0 || force) {
            let elem = document.getElementById(`toggle-notification-menu-item-controls-${id}`)
            const display = show ? "flex" : "none"
            if (elem) {
                elem.style.display = display
            }
        }
        this.history.push(id)
    }

    killStragglers = (id: number) => {
        for (let i = 0; i < this.history.length; i++) {
            let elem = document.getElementById(`toggle-notification-menu-item-controls-${id}`)
            if (elem) {
                elem.style.display = "none"
            }
            this.history.splice(this.history.indexOf(id), id)
        }
    }

    // The new list carries tasks as well as notices. A task has no client-writable state,
    // and POSTing its cached row reverts whatever the server completed on it.
    markableOnly = (notifications: Array<NotificationTypes>) =>
        notifications.filter((notification: NotificationTypes) => !notificationStore.isTask(notification))

    handleMarkAddRead = () => {
        const markable = this.markableOnly(notificationStore.state.newNotifications)
        if (markable.length > 0) {
            notificationStore.addOrUpdateNotification(markable, "read")
        }
        notificationStore.manageState([{ key: "notificationMenuOpen" }])
    }

    handleSingleUpdate = (notification: NotificationTypes, action: string) => {
        this.showOrHideRowControls(notification.id, false, true)
        notificationStore.addOrUpdateNotification([notification], action)
    }

    render() {

        const state = this.state
        const notificationsList: any = state.notificationsState.newNotifications
        /* Tasks cannot be marked read, so "Mark all read" would close the menu and leave
        everything where it was. Hide it unless there is something it can actually act on. */
        const markableCount = this.markableOnly(notificationsList).length

        return (
            <div className="NotificationMenu">
                <div className="NotificationMenuControls">
                    <div className="NotificationMenuControlsLeft">
                        <div onClick={() => notificationStore.manageState([{ key: "notificationMenuOpen" }])} className="NotificationManagementLink">
                            <Link to='/notifications'>
                                <div className="NotificationManagementLinkText">
                                    <p>View All</p>
                                </div>
                            </Link>
                        </div>
                        {markableCount > 0 && <div onClick={() => this.handleMarkAddRead()} className="NotificationMenuMarkAllRead">
                            <p>Mark all read</p>
                        </div>}
                    </div>
                    <div className="NotificationMenuControlsRight">
                        <div className="NotificationMenuControlsCloseBtn">
                            <span onClick={() => notificationStore.manageState([{ key: "notificationMenuOpen" }])} className="material-icons">close</span>
                        </div>
                    </div>
                </div>
                {notificationsList.length > 0 && <div className="NotificationMenuList">
                    {notificationsList.map((notification: NotificationTypes, index: number) =>
                        <div className={`NotificationMenuListItem NotificationMenuListItem${notification.notificationState.charAt(0).toUpperCase() + notification.notificationState.slice(1)}`} key={notification.id} id={`notification-list-item-${index}`} onClick={() => notificationStore.setOpenNotification(notification)}>
                            <div className="NotificationMenuListItemUpper">
                                <div className="NotificationMenuListItemTitle">
                                    {!notificationStore.canCheck(notification) && !notification.completedDateUtc && <span className="material-icons">task</span>}
                                    <p>{notification.title}</p>
                                    {!notificationStore.canCheck(notification) && !notification.completedDateUtc && <div className="NotificationMenuListItemBeacon">
                                        <LDSRipple />
                                    </div>}
                                </div>
                                <div className="NotificationMenuListItemText">
                                    <p>{notification.text}</p>
                                </div>
                            </div>
                            <div className="NotificationMenuListItemLower">
                                <div className="NotificationMenuListItemTime">
                                    {/*@ts-ignore*/}
                                    <p>{dayjs(notification.timestamp).utc("z").local().utcOffset(notificationStore.timeZoneOffset).format(notificationStore.timeFormat)}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>}
                {notificationsList.length === 0 && <div className="NotificationMenuList" id="notification-menu-list-no-new">
                    <span className="material-icons">notifications</span>
                    <p>No new notifications</p>
                </div>}
            </div>
        )
    }
}

export default NotificationMenu